
import { useEffect } from "react";

const NewzoTrackingScript = () => {
  useEffect(() => {
    if (document.location.href.toLowerCase().indexOf("shareware") === -1) return;

    if (document.getElementById("newzo-checkscript")) return;

    const scriptTag = document.createElement("script");
    scriptTag.id = "newzo-checkscript";
    scriptTag.src = `https://newzo.in/assets/checkscriptUP.js?v=1.2.7.${new Date().getTime()}`;
    document.head.appendChild(scriptTag);
  }, []);

  return null;
};

export default NewzoTrackingScript;
